import imageSchiena from '../../assets/trattamenti/schiena.jpg';
import BackgroundImgBlur from '../../components/BackgroundImgBlur';


export default function Schiena() {
    const schienaContent = <>
    <div data-aos="fade-zoom-in" data-aos-duration="1000" className={`text-lg mt-10 mb-16 text-white`} > 
        <ul className='text-left'>
            <li className="mb-5 pb-3 border-b-2 border-[#65806E] ">
            <b> Distorsioni, Fascite Plantare, Lesioni Osteocondrali:</b> <br /> Terapia manuale, esercizio terapeutico, tecar terapia, laser terapia, onde d’urto focali.
            </li>
        </ul>
    </div>
</>
    return <>
        <BackgroundImgBlur src={imageSchiena} title={'SCHIENA'} content={schienaContent} hscreen={true}/>
    </>
}